import React, {useEffect} from "react";
import { useRequiredStore } from "../../../../utils/store";
import { RootStoreContext } from "../../../../stores/root/root.store";
import { isAllowed } from "../../../../utils/helpers";
import {RouteConfig} from "../../../../routers/routers";
import {useNavigate} from "react-router";
import {useMatches} from "react-router-dom";

export const ExtendedRoute: React.FC<{config: RouteConfig}> = ({config}) => {
    const Component = config.component;
    const store = useRequiredStore(RootStoreContext);
    const authStore = store.authStore;
    const navigate = useNavigate();

    useEffect(() => {
        if (store.authStore.inited) {
            if (!store.authStore.isLoggedIn || (!isAllowed(authStore.attributes, config.access) && (!config.role || config.role === authStore.role))) {
                navigate('/login');
            }
        }
    }, [navigate, store.authStore.inited, store.authStore.isLoggedIn]);

    return <Component
        name={config.name}
        requiredConfigs={config.configData}
        routeChildren={config.children}
    />
};